import { useEffect } from 'react';
import { setEnvironmentWithSaveData } from '../utils/webview/messages';

interface EnvironmentSwitchModalProps {
    environment: string;
    navigateTo: string;
    email?: string;
    station?: string;
}

const EnvironmentSwitchModal: React.FC<EnvironmentSwitchModalProps> = ({
    environment,
    navigateTo,
    email,
    station,
}) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            setEnvironmentWithSaveData(environment, {
                navigateTo,
                ...(email ? { email } : {}),
                ...(station ? { station } : {}),
            });
        }, 4000);

        return () => clearTimeout(timer);
    }, [environment, navigateTo, email, station]);

    return (
        <div className="modal" id="environment_switch_modal">
            <div
                className="modal__background"
                id="environment_switch_modal_background"
            >
                <div className="full-modal">
                    <div className="full-modal__panel">
                        One moment
                        <br />
                        <br />
                        {station
                            ? 'Processing your request. Start your session on the next screen.'
                            : 'Processing your request. Continue your authentication on the next screen.'}
                        <div className="lg-loader" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnvironmentSwitchModal;
